import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
  en: {
    translation: {
      
    }
  },
  es: {
    translation: {
      "leagues": "Ligas",
      "league": "Liga",
      "create_league": "Crear liga",
      "edit_league": "Editar liga",
      "remove_league": "Borrar liga",
      "are_you_sure_you_want_to_remove_this_league?": "¿Estás seguro que quieres borrar esta liga?",
      "code": "Código",
      "name": "Nombre",
      "clubs": "Clubs",
      "club": "Club",
      "create_club": "Crear club",
      "edit_club": "Editar club",
      "remove_club": "Borrar club",
      "are_you_sure_you_want_to_remove_this_club?": "¿Estás seguro que quieres borrar este club?",
      "players": "Jugadores",
      "player": "Jugador",
      "create_player": "Crear jugador",
      "edit_player": "Editar jugador",
      "remove_player": "Borrar jugador",
      "are_you_sure_you_want_to_remove_this_player?": "¿Estás seguro que quieres borrar este jugador?",
      "alias": "Alias",
      "lastname": "Apellido",
      "second_lastname": "Segundo apellido",
      "nif": "DNI",
      "birthdate": "Fecha de nacimiento",
      "email": "Email",
      "phone": "Teléfono",
      "nationality": "Nacionalidad",
      "paid": "Pagado",
      "data_protection": "Protección de datos",
      "club_id": "Club",
      "category_id": "Categoría",
      "full_name": "Nombre completo",
      "categories": "Categorías",
      "category": "Categoría",
      "create_category": "Crear categoría",
      "edit_category": "Editar categoría",
      "remove_category": "Borrar categoría",
      "are_you_sure_you_want_to_remove_this_category?": "¿Estás seguro que quieres borrar esta categoría?",      
      "league_id": "Liga",      
      "days": "Días de juego",
      "games": "Partidos",
      "game": "Partido",
      "create_game": "Crear partido",
      "edit_game": "Editar partido",
      "remove_game": "Borrar partido",
      "are_you_sure_you_want_to_remove_this_game?": "¿Estás seguro que quieres borrar este partido?",
      "game_day": "Jornada",
      "date": "Fecha",
      "time": "Hora",
      "first_player_id": "Jugador 1",
      "second_player_id": "Jugador 2",
      "first_player_forfeit": "Jugador 1 no presentado",
      "second_player_forfeit": "Jugador 2 no presentado",
      "first_player_score": "Resultado jugador 1",
      "second_player_score": "Resultado jugador 2",
      "first_player_score_column": "Res j1",
      "second_player_score_column": "Res j2",
      "status": "Estado",      
      "game_status_0": "Por jugar",
      "game_status_1": "Jugado",
      "game_status_2": "Pendiente de revisión",
      "game_status_3": "Validado",
      "Save changes": "Guardar",
      "save_changes": "Guardar",
      "Cancel": "Cancelar",
      "sign_in": "Iniciar sesión",
      "all_game_days": "Todas las jornadas",
      "type": "Tipo",
      "tournament": "Torneo",
      "tournament_type": "Tipo de torneo",
      "single_elimination": "Eliminación simple",
      "double_elimination": "Eliminación doble",
      "torunament_participants": "Participantes",
      "bracket": "Cuadrante",
      "select_bracket": "Selecciona un cuadrante",
      "simple_8": "Simple 8 jugadores",
      "simple_16": "Simple 16 jugadores",
      "simple_32": "Simple 32 jugadores",
      "double_8": "Doble 8 jugadores",
      "generate_games": "Generar partidos",
      "are_you_sure_you_want_to_generete_the_games_of_this_category?": "¿Estás seguro que quieres generar los partidos de esta categoría?",
      "password": "Contraseña",
      "close": "Cerrar",
      "img": "Imagen",
      "statistics": "Estadísticas",
      "player_id": "Jugador a inscribir",
      "enroll_player": "Inscribir jugador",
      "unenroll_player": "Desinscribir jugador",
      "are_you_sure_you_want_to_unenrollment_this_player?": "¿Estás seguro que quieres desinscribir a este jugador?",
      "are_you_sure_you_want_to_mark_as_paid?": "¿Estás seguro que quieres marcar como pagado?",
      "are_you_sure_you_want_to_mark_as_unpaid?": "¿Estás seguro que quieres marcar como no pagado?",
      "mark_as_paid": "Marcar como pagado",
      "mark_as_unpaid": "Marcar como no pagado",
      "start_date": "Fecha de inicio",
      "day": "Día",
      "start_hour": "Hora de inicio",
      "two_rounds": "Ida y vuelta",
    }
  },  
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "es", // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option

    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

  export default i18n;